import { useEffect, useState } from "react";
import Grid from "../components/general/Grid";
import SlideMenu from "../components/general/SlideMenu";
import Config from "../models/Config";

export default function Araviz (props) {
    /* MODIFY NAME */
    const ConfigVar = Config.araviz;


  const { setColorBg, setLogoHeader, setShowSpecies } = props;

  useEffect(() => {
    setColorBg(ConfigVar.color);
    setLogoHeader(ConfigVar.header);
    setShowSpecies(false);
  }, []);

  const [open, setOpen] = useState(false);
  const [contentSlideMenu, setContentSlideMenu] = useState();

  const openMenu = () => {
    setOpen(true);
  }

  console.log(ConfigVar.apps);

  return (
    <>
    <div className="text-center">
        <SlideMenu open={open} setOpen={setOpen} content={contentSlideMenu} ></SlideMenu>
        <Grid openMenu={openMenu} setContentSlideMenu={setContentSlideMenu} ConfigVar={ConfigVar} />
      </div>
    </>
  );
};